'use client'
import { useTranslations } from 'next-intl'
import { useEffect, useState } from 'react'
import { APIClient } from '../helpers/api_helper'
import useFavoritesStore from '../stores/favoritesStore'
import Card from '../components/Card'
import { useLocale } from 'use-intl'

export default function ClientFavoritesComponent() {
  const t = useTranslations('')
  const favorites = useFavoritesStore(state => state.favorites)
  const [data, setData] = useState([]);

  const currentLanguage = useLocale()

  useEffect(() => {
    const api = new APIClient();
    const fetchData = async () => {
      const params = {estates: favorites.join(',')};
      try {
        api.get(`/site/favorites/`, params, {"Accept-Language": currentLanguage}).then(data => {
          // @ts-ignore
          setData(data)
        });
      } catch (error) {
        console.error("Error fetching estate data", error);
      }
    };

    fetchData();
  }, [currentLanguage, favorites]);

  return (
    <main>
      <div className='simpleContainer'>
        <div className='container-sections'>
          <h1>{t('Favorites')}</h1>
          <p className='container-sub-title'>
            {t('Here you can find all your favourites')}
          </p>
        </div>
      </div>
      <div className='gray-background best-offers container-for-best-offers'>
        <section className='container-main'>
          <div className='home_best_offers w-100'>
            {data.map((item: any) => (
              <Card key={item.id} data={item} favoriteIconRef={undefined}
                    withSlider={true}/>
            ))}
          </div>
        </section>
      </div>
    </main>
  )
}
